export default __webpack_public_path__ + "static/media/cctv.50015ff2.jpg";